const PREFIX = 'ME/';
// eslint-disable-next-line import/prefer-default-export
export const ME_RETRIEVE = `${PREFIX}RETRIEVE`;
